// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useMemo} from 'react';
import {all_plans, plans_config, www_hola} from 'hola_opt';
import {oculus_proxy_type} from '../../types';

interface t_plans {
    id: string;
    price: number;
    period: string;
    type: oculus_proxy_type;
}

export interface i_oculus_plans {
    all_plans: {
        type: {
            id: t_plans;
        };
    };
    plans_config: typeof plans_config;
    ui_plans: typeof www_hola.ui_plans;
}

export const use_plans = ()=>{
    const oculus_plans = useMemo(()=>{
        const by_obj = {} as i_oculus_plans;
        by_obj.all_plans = all_plans.reduce((acc, plan)=>{
            const {id, type, period} = plan;
            const mappedType = type == 'events_resi_group' ?
                'events_resi_tickets' : type;
            acc[mappedType] = acc[mappedType] ?? {};
            acc[mappedType][id] = {...plan, period, type: mappedType};
            return acc;
        }, {} as i_oculus_plans['all_plans']);
        by_obj.plans_config = plans_config;
        by_obj.ui_plans = www_hola.ui_plans;
        return by_obj;
    }, []);
    return oculus_plans;
};
